import e from "react";
import { mintelBlue600 as i, cmBlue600 as u } from "mintel-tokens";
import { u as p } from "./ThemeProvider--i7ESlT5.es.js";
import { D as d } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as a } from "./index-BB-Wk85r.es.js";
import { T as f } from "./Tooltip-DPAGXB4Y.es.js";
import { g } from "./utils-Ci4OZEP4.es.js";
import './Pill.css';const v = "Pill-module__oval___4Zqye", l = {
  oval: v
}, k = ({
  children: t,
  color: m = null
}) => {
  const n = p(), r = {
    compere: u,
    default: i
  }, o = m ?? r[n] ?? r.default, s = g(o, "Card.Pill"), c = /* @__PURE__ */ e.createElement(d, { darkMode: s }, /* @__PURE__ */ e.createElement("div", { className: l.oval, style: { backgroundColor: o } }, /* @__PURE__ */ e.createElement(a.Heading6, { oneLineTruncate: !0, responsive: !0, tagName: "span" }, t)));
  return /* @__PURE__ */ e.createElement("div", { className: l.container }, /* @__PURE__ */ e.createElement(
    f.Hover,
    {
      dark: !0,
      trigger: c,
      placement: "top",
      accessible: !1,
      short: !0
    },
    /* @__PURE__ */ e.createElement(a.Body2, { darkBg: !0, oneLineTruncate: !0, responsive: !0, tagName: "span" }, t)
  ));
};
k.displayName = "Pill";
export {
  k as P
};
